/** Tooltip when start/end time pickers are disabled until start and end dates match. */
export const TIME_FILTERS_SAME_DATE_TOOLTIP =
  "Both start and end date must be the same in order for start and end time filters to be enabled.";

export const timeFiltersSameDateTooltipComponentsProps = {
  tooltip: {
    sx: { fontFamily: "Mulish", maxWidth: 320 },
  },
};

/**
 * Shared Tooltip props for the time pickers. Anchored below the field with
 * flipping disabled: when the filter bar stacks (narrow window) a top-placed
 * tooltip lands on the row of filters above and hides them. Overflow is
 * corrected by sliding along the field instead of jumping to the other side.
 */
export const timeFiltersSameDateTooltipProps = {
  placement: "bottom" as const,
  componentsProps: timeFiltersSameDateTooltipComponentsProps,
  PopperProps: {
    modifiers: [
      { name: "flip", enabled: false },
      { name: "preventOverflow", options: { altAxis: false, padding: 8 } },
    ],
  },
};
